module.exports = "/_next/static/images/candle-23a19164a95ddde7edf00a4f583ce353.png";